import moment from 'moment';
import { AdminPerson } from 'static/classes/Person';
import { RecommendationsTemplateVM } from 'static/components/email-composer';
import { Modal } from 'bootstrap';
import { AdminEvent } from 'static/classes/Event';
import { setDataAndShowDetailsModal } from 'static/components/details-modal/details-modal';

export function MatchmakingViewModel(data){
    var self = this;
    self.type = "MatchmakingViewModel";

    self.rootvm = data.rootvm;
    self.internal_navigate = ko.observable(true);
    self.history_pop_subscribe;

    self.history_pop = function(options){
        // This will fire on no match
        if (options.route.length === 0 && self.initialized() && !self.internal_navigate() &&
            pager.activePage$().id() == 'matchmaking') {
            // do the search here
            //console.log('history pop');
            //console.log('search query is ', self.search_query());
            self.lookup_events(false);
        }
        if(self.internal_navigate() == true){
            self.internal_navigate(false);
        }
        // scroll to the top
        $('html, body').scrollTop(0)
    }

    self.monthly_stats = ko.observableArray([]);
    self.yearly_stats = ko.observableArray([]);

    self.monthLabel = function(mo) {
        return ['', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][mo] || mo;
    };

    self.pct = function(numerator, denominator) {
        if (!denominator) return '';
        return '(' + Math.round((numerator / denominator) * 100) + '%)';
    };

    self.lookup_stats = function() {
        return $.ajax({
            url: self.rootvm.web_host + '/api/admin/matchmaking/stats',
            type: 'GET',
            success: function(data) {
                self.monthly_stats(data.monthly);
                self.yearly_stats(data.yearly);
            },
        });
    };

    self.initialized = ko.observable(false);
    self.initialize = function(){
        if (self.offset() == undefined){
            self.offset(0);
        }
        if (self.limit() == undefined){
            self.limit(10);
        }

        self.history_pop_subscribe = pager.onNoMatch.add(self.history_pop);
        self.lookup_stats();
        self.initialized(true);
    };

    self.afterHide = function(){
        self.history_pop_subscribe = pager.onNoMatch.remove(self.history_pop);
    }


    self.total_count = ko.observable();
    self.filtered_count = ko.observable();
    self.offset = ko.observable(0);
    self.limit = ko.observable(10);

    self.selected_rec = ko.observable();

    self.events = ko.observableArray([]);

    self.event_actions = ko.observableArray(['confirmed', 'waiting_for_approval', 'waiting_for_confirmation', 'no_by_host', 'no_by_artist', 'cancelled']);
    self.event_categories = ko.observableArray([ 'sofaconcert', 'wedding', 'other', 'birthday', 'family_event', 'charity', 'contest', 'special_occassion', 'corporate_event', 'livestream', 'external']);


    self.filter_event_action = ko.observableArray([]);
    self.filter_event_category = ko.observableArray([]);
    self.selection = ko.observable('invitations');
    self.dateSearchType = ko.observable('event');

    self.error = ko.observable();
    self.search_query = ko.observable();
    self.search_fee = ko.observable();
    self.search_date = ko.observable();
    self.search_no_gig_option = ko.observable();
    self.confirms = ko.observable(false);
    self.high_value = ko.observable(false);
    self.host_accept = ko.observable(false);
    self.host_decline = ko.observable(false);
    self.invite_sent = ko.observable(false);
    self.approve_no_accept = ko.observable(false);
    self.sent_gig_but_no_approve= ko.observable();
    self.rec_only = ko.observable();
    self.show_all = ko.observable(false);
    self.search_type = ko.observable(undefined);

    self.search_click = function(){
        //reset offset
        self.offset(0);
        self.lookup_events();
    }

    self.create_search_link_from_event_data = function(event_data){
        var genres = "";
        if(event_data.genres !== null && event_data.genres.length > 0){
            ko.utils.arrayForEach(event_data.genres, (d)=>{
                genres += 'genre[]=' + (d.toLowerCase() == 'singer' ? 'singer songwriter' : d.toLowerCase()) + '&';
            });
        }
        var link = `https://www.sofaconcerts.org/de/artists?location_name=${event_data.location_name}&latitude=${event_data.latitude}&longitude=${event_data.longitude}&event_type_q=${event_data.event_type}&${genres}`;

        return link;

    }


    self.row_style = function(event_state){
        // event_state arrives as a plain string from related_events / gig_offers.
        // Use subtle bg-* classes (not table-*) so the colour renders on the <li>.
        const state = (typeof event_state === 'function') ? event_state() : event_state;
        switch (state) {
            case 'confirmed':                 return 'bg-success-subtle fw-bold';
            case 'waiting_for_confirmation':  return 'bg-warning-subtle';
            case 'waiting_for_approval':      return 'bg-danger-subtle';
            case 'cancelled':                 return 'bg-info-subtle';
            default:                          return '';
        }
    };

    self.create_navigation_string = function(){

        var navigation_string = ("#concerts/matchmaking"
            + "?offset="
            + self.offset()
            + "&limit="
            + self.limit()
        );

        if(self.search_query()){
            navigation_string += "&search_query="
            + self.search_query()
        }

        if(self.selection()){
            navigation_string += "&selection="
            + self.selection();
        }

        if(self.dateSearchType()){
            navigation_string += "&dateSearchType="
            + self.dateSearchType();
        }

        if(self.filter_event_action()){

            ko.utils.arrayForEach(self.filter_event_action(), function(filter){
                navigation_string += "&filter_event_action[]="
                + filter;
            });
        }

        if(self.filter_event_category()){
            ko.utils.arrayForEach(self.filter_event_category(), function(filter){
                navigation_string += "&filter_event_category[]="
                + filter;
            });
        }

        return navigation_string;
    }

    self.lookup_events = function(set_internal_navigate){
        if (self.offset() == undefined || self.offset() == 'undefined'){
            self.offset(0);
        }
        if (self.limit() == undefined || self.limit() == 'undefined'){
            self.limit(10);
        }

        if(self.initialized && !self.rootvm.is_busy()){

            self.rootvm.is_busy(true);
            return $.ajax({

                url: self.rootvm.web_host + '/api/admin/events-needing-suggestions',
                type: 'GET',
                data:{
                    limit: self.limit(),
                    offset: self.offset(),
                    search: self.search_query(),
                    event_type: self.filter_event_category(),
                    date_search_type: self.dateSearchType(),
                    min_fee: self.search_fee(),
                    rec_only: self.rec_only(),
                    show_all: self.show_all(),
                    confirms: self.confirms(),
                    approve_no_accept: self.approve_no_accept(),
                    host_accept : self.host_accept(),
                    host_decline : self.host_decline(),
                    invite_sent : self.invite_sent(),
                    sent_gig_but_no_approve : self.sent_gig_but_no_approve(),
                    search_no_gig_option: self.search_no_gig_option(),
                    high_value : self.high_value()

                },

                contentType: "application/json; charset=utf-8",

                complete: function(data){
                    self.rootvm.is_busy(false);
                },

                success: function (data) {

                    self.events(ko.utils.arrayMap( data.people || [],
                        function(x){
                            x.person.rootvm = self.rootvm
                            const p = new AdminPerson(x.person);

                            x.inserted = new moment(x.inserted);

                            x.possible_dates = ko.utils.arrayMap(x.possible_dates || [],
        					function(y){
            					return new moment(y);
    						});

							// Set of artist_uuids we actually recommended to this
							// person, so invites for those artists can be starred.
							const recommended_artist_uuids = new Set();
							(x.sent_recommendation_emails || []).forEach(function(rec){
								(rec.rcmd_artists || []).forEach(function(a){
									if (a.artist_uuid) recommended_artist_uuids.add(a.artist_uuid);
								});
							});

							// The recommendation request time (only meaningful for
							// reco rows). x.inserted is already a moment by here.
							const reco_requested_at = x.recommendation_uuid ? x.inserted : null;

							// The earliest time we actually emailed recommendations
							// to this person.
							let reco_emailed_at = null;
							(x.sent_recommendation_emails || []).forEach(function(rec){
								if (rec.inserted) {
									const t = new moment(rec.inserted);
									if (!reco_emailed_at || t.isBefore(reco_emailed_at)) {
										reco_emailed_at = t;
									}
								}
							});

							x.related_events = (x.related_events || []).map(function(re){
								re.was_recommended = recommended_artist_uuids.has(re.artist_uuid);
								const invited_at = new moment(re.inserted);
								re.sent_after_reco_request = reco_requested_at
									? invited_at.isAfter(reco_requested_at)
									: false;
								re.sent_after_reco_email = reco_emailed_at
									? invited_at.isAfter(reco_emailed_at)
									: false;
								return re;
							});
							x.gig_offers = ko.observableArray(x.gig_offers) ;
							x.rcmd_artists_sent_on = ko.observable();

                            x.admin_closed = ko.observable(false);
                            x.closed_by_user = ko.observable(x.closed_by_user);
                            x.person = p;

                            x.no_match_email_sent  = ko.observable(x.no_match_email_sent);
                            if(x.admin_booking_possibility == null){
                                x.admin_booking_possibility = undefined;
                            }
                            x.admin_booking_possibility = ko.observable(x.admin_booking_possibility);
                            x.admin_booking_possibility.subscribe(()=>  {return self.booking_possiblity_changed(x.recommendation_uuid, x.admin_booking_possibility())});

                            x.link = self.create_search_link_from_event_data(x);
                            return x
                        }));

                    self.total_count(data.total_count);
                    self.filtered_count(data.total_count);
                    self.rootvm.is_busy(false);

                    var navigation_string = self.create_navigation_string();

                    // this navigation is coming from us, so dont search
                    // again
                    if(set_internal_navigate !== false){
                        self.internal_navigate(true);
                    }

                    //console.log('internal navigate is', self.internal_navigate());
                    pager.navigate(navigation_string);
                },

                error: function (data) {
                    self.error(data.statusText);
                    self.events.removeAll();
                    self.rootvm.is_busy(false);
                }
            });
        }
    };

    self.booking_possiblity_changed = function(recommendation_uuid, booking_possiblity){
        console.log("CHANGED! ", booking_possiblity);

        return $.ajax({
            url: scvm.web_host + '/api/admin/recommendation/save-booking-possibility',
            type: 'POST',
            data:ko.toJSON({
                recommendation_uuid: recommendation_uuid,
                booking_possiblity: booking_possiblity
            }),
            processData: false,

            contentType: "application/json; charset=utf-8",

            success: function (data) {

               if (data.success){
                   notyf.success("saved");
               }
               else{
                   notyf.error(data.message);
               }

            },
            error: function (jqXHR, errorStatus, thrownError) {
                var response = jQuery.parseJSON(jqXHR.responseText);
                notyf.error(response.message);
            },
            complete: function(){
            }
        });

    }

    self.get_login_link = function(row){
        row.person.get_login_link("/dashboard");
    };

    self.set_selected_data = (e, tabId) => {
        const relatedEvents = e.related_events.map((ev) => new AdminEvent({ rootvm: self.rootvm, event_uuid: ev.event_uuid }));
        e.person.events(relatedEvents);
        const data = tabId === 'host' ? e.person : new AdminEvent({ rootvm: self.rootvm, event_uuid: e.event_uuid });
        setDataAndShowDetailsModal(data, tabId);
    };

    // Open the history tab for a single invite / gig offer. The info buttons in
    // the "Related" and "gig matches" columns iterate individual events, so we
    // build the modal from that specific item's event_uuid.
    self.show_event_history = (eventLike) => {
        if (!eventLike || !eventLike.event_uuid) return;
        const data = new AdminEvent({ rootvm: self.rootvm, event_uuid: eventLike.event_uuid });
        setDataAndShowDetailsModal(data, 'history');
    };

    self.lower_count_label = ko.computed(function(){
        return parseInt(self.offset()) + 1;
    });

    self.upper_count_label = ko.computed(function(){
        if (parseInt(self.limit()) + parseInt(self.offset()) > self.filtered_count())
        {
            return self.filtered_count();
        }
        else
        {
            return parseInt(self.limit()) + parseInt(self.offset());
        }
    });

    self.paging_visible = ko.computed(function () {
        return self.total_count() > 0;
    });

    self.next_button_visible = ko.computed(function() {
        return parseInt(self.offset()) + parseInt(self.limit()) < self.filtered_count();
    });

    self.previous_button_visible = ko.computed(function () {
        return parseInt(self.offset()) > 0;
    });



    self.go_left = function () {

        if (self.rootvm.is_busy()){
            return false;}

        self.offset(parseInt(self.offset()) - parseInt(self.limit()));

        self.lookup_events();

    };

    self.go_right = function () {

        if (self.rootvm.is_busy()){
            return false;}

        self.offset(parseInt(self.offset()) + parseInt(self.limit()));
        self.lookup_events();
    };

    // No matches found modal open
    self.no_matches_email_click = (row) =>{
        console.log("No matches found for invite")

        let confirm_answer = confirm("Send email informing host that we have no gig options.");
        if(confirm_answer == true){
            // ajax here
            return $.ajax({
                url: scvm.web_host + '/api/admin/recommendation/no-reco-results',
                type: 'POST',
                data:ko.toJSON({
                    recommendation_uuid: row.recommendation_uuid,
                }),
                processData: false,

                contentType: "application/json; charset=utf-8",

                success: function (data) {

                   if (data.success){
                       //row.closed_by_user(new Date());
                       //
                       row.no_match_email_sent(true);

                       notyf.success("email sent");
                   }
                   else{
                       notyf.error(data.message);
                   }

                },
                error: function (jqXHR, errorStatus, thrownError) {
                    var response = jQuery.parseJSON(jqXHR.responseText);
                    notyf.error(response.message);
                },
                complete: function(){
                }
            });

        }
    }

    self.recommendations_email_vm = new RecommendationsTemplateVM({ rootvm: self.rootvm });

    self.set_send_new_recommendations = async (rec) => {
        const vm = self.recommendations_email_vm;

        if (vm.all_artists().length === 0) {
            vm.lookup_all_artists();
            vm.display_name(self.rootvm.webapp_session().user().display_name());
        }

        if (rec.recommendation_uuid != vm.recommendation_uuid()) {
            vm.recommendation_uuid(rec.recommendation_uuid);
            vm.event_type(rec.event_type);
            vm.date(rec.possible_dates[0]);
            vm.host_name(rec.person.display_name());
            vm.person_uuid(rec.person.person_uuid());
            const langMap = { german: 'de', english: 'en', french: 'fr' };
            const rawLang = rec.person.language();
            console.log('[matchmaking] language raw:', rawLang);
            vm.language(undefined);
            vm.language(langMap[rawLang]);
            vm.recommend_artists([]);
            vm.ai_prepopulate_reasoning('');
            vm.ai_prepopulate_error('');
            vm.ai_prepopulate_loading(false);
            vm.ai_extra_instructions('');
            vm.sections().forEach(s => s.value(''));
        }

        const modal = document.getElementById('modalMatchSendNewRecommendations');
        Modal.getOrCreateInstance(modal).show();
    };

    // GIG Option Pop up
    //
    self.match_search_results = ko.observableArray([]);
    self.match_search_name = ko.observable();
    self.match_message = ko.observable();
    self.gig_artists_selected = ko.observableArray([]);
    self.sending_gig_requests = ko.observable(false);
    self.open_gig_option =  (row) => {
        if(row != self.selected_rec()){

            self.selected_rec(row);
            self.prepopulate_artist_matches();
            self.gig_artists_selected([]);
            self.recommendations([]);
            self.match_message(row.additional_info);
        }
        const matchGigOption = document.getElementById('matchGigOption');
        Modal.getOrCreateInstance(matchGigOption).show();
    }

    self.edit_fee_for = ko.observable(-1);
    self.edit_fee_value = ko.observable();

    self.prepopulate_artist_matches = () => {

        if(self.selected_rec().recommendation_uuid){
            self.match_search_results([])

            return $.ajax({
                url: self.rootvm.web_host + '/api/admin/prepopulate-artist-matches',
                type: 'GET',
                data:{
                    recommendation_uuid:self.selected_rec().recommendation_uuid,
                },

                contentType: "application/json; charset=utf-8",

                complete: function(data){
                    self.rootvm.is_busy(false);
                },

                success: function (data) {
                    ko.utils.arrayForEach(data.artists, (item) =>{
                        item.fee = ko.observable(item.fee);
                    });
                    self.match_search_results(data.artists)
                    //self.gig_artists_selected.push(data.artists);


                    self.rootvm.is_busy(false);
                },

                error: function (data) {
                    self.error(data.statusText);
                    self.match_search_results.removeAll();
                    self.rootvm.is_busy(false);
                }
            });

        }


    }

    self.search_artist_matches = () => {
        self.rootvm.is_busy(true);
        self.recommendations([]);
        self.error();
        return $.ajax({

            url: self.rootvm.web_host + '/api/admin/search-artist-matches',
            type: 'GET',
            data:{
                search: self.match_search_name(),
                event_type : self.selected_rec().event_type,
            },

            contentType: "application/json; charset=utf-8",

            complete: function(data){
                self.rootvm.is_busy(false);
            },

            success: function (data) {
                ko.utils.arrayForEach(data.artists, (item) =>{
                    item.fee = ko.observable(item.fee);
                });
                self.match_search_results(data.artists)
            },

            error: function (data) {
                self.error(data.statusText);
                self.match_search_results.removeAll();
                self.rootvm.is_busy(false);
            }
        });
    }

    self.search_artist_similar_matches = () => {
        self.rootvm.is_busy(true);
        self.recommendations([]);
        self.error();
        return $.ajax({

            url: self.rootvm.web_host + '/api/admin/search-artist-similar-matches',
            type: 'GET',
            data:{
                recommendation_uuid : self.selected_rec().recommendation_uuid
            },

            contentType: "application/json; charset=utf-8",

            complete: function(data){
                self.rootvm.is_busy(false);
            },

            success: function (data) {
                ko.utils.arrayForEach(data.artists, (item) =>{
                    item.fee = ko.observable(item.fee);
                });
                self.match_search_results(data.artists)
                self.gig_artists_selected(self.gig_artists_selected().concat(data.artists));

                self.rootvm.is_busy(false);
            },

            error: function (data) {
                self.error(data.statusText);
                self.match_search_results.removeAll();
                self.rootvm.is_busy(false);
            }
        });
    }


    self.send_gig_match_requests = () => {
        self.sending_gig_requests(true);
        self.rootvm.is_busy(false);

        return $.ajax({

            url: self.rootvm.web_host + '/api/admin/event/gig-matchmaking',
            type: 'POST',
            data: ko.toJSON({
                person_uuid : self.selected_rec().person.person_uuid,
                message: self.match_message(),
				recommendation_uuid: self.selected_rec().recommendation_uuid,
				matched_event_uuid: self.selected_rec().event_uuid,
                selected_artists : self.gig_artists_selected().map(
					(item) => ({artist_uuid: item.artist_uuid, fee: item.fee}) )
            }),

            contentType: "application/json; charset=utf-8",

            complete: function(data){
                self.rootvm.is_busy(false);
            },

            success: function (data) {
                self.sending_gig_requests(false);
                self.match_search_results([]);
                self.recommendations([]);
                self.gig_artists_selected([]);
                self.match_search_name(undefined);
                const matchGigOption = document.getElementById('matchGigOption');
                Modal.getInstance(matchGigOption)?.hide();

		//let new_array = self.selected_rec().gig_offers().concat(data.gig_offers);
		self.selected_rec().gig_offers(data.gig_offers);

            },

            error: function (data) {
                self.error(data.statusText);
                self.sending_gig_requests(false);
                self.rootvm.is_busy(false);
            }
        });


        setTimeout ( () => {
        }, 3000)
    }

    self.add_gig_match = (item) => {
        console.log("adding gig match");
	if(self.gig_artists_selected().indexOf(item) < 0){
        	self.gig_artists_selected.push(item);
	}
    }

    self.remove_gig_match = (item) =>{
        self.gig_artists_selected.remove(item);
    }

    //
    //Admin close
    self.row_to_close;
    self.user_close_click = (row) => {
        self.row_to_close = row;
        const closeGigOption = document.getElementById('closeGigOption');
        Modal.getOrCreateInstance(closeGigOption).show();
    }

    self.user_close = (type) => {
        console.log('closing !' , type);
        return $.ajax({
            url: scvm.web_host + '/api/admin/people/close-reco',
            type: 'POST',
            data:ko.toJSON({
                person_uuid: self.row_to_close.person.person_uuid(),
                recommendation_uuid: self.row_to_close.recommendation_uuid,
                type: type,
            }),
            processData: false,

            contentType: "application/json; charset=utf-8",

            success: function (data) {

               if (data.success){
                   self.row_to_close.closed_by_user(new Date());

                   notyf.success("closed");
               }
               else{
                   notyf.error(data.message);
               }

            },
            error: function (jqXHR, errorStatus, thrownError) {
                var response = jQuery.parseJSON(jqXHR.responseText);
                notyf.error(response.message);
            },
            complete: function(){
                self.row_to_close = null;
            }
        });

        //row.admin_closed(true);
    }

    self.admin_close = (row) => {
        return $.ajax({
            url: scvm.web_host + '/api/admin/recommendation/close',
            type: 'POST',
            data:ko.toJSON({
                recommendation_uuid: row.recommendation_uuid,
                event_uuid: row.event_uuid,
            }),
            processData: false,

            contentType: "application/json; charset=utf-8",

            success: function (data) {

               if (data.success){
                   row.admin_closed(true);

                   notyf.success("closed");
               }
               else{
                   notyf.error(data.message);
               }

            },
            error: function (jqXHR, errorStatus, thrownError) {
                var response = jQuery.parseJSON(jqXHR.responseText);
                notyf.error(response.message);
            },
            complete: function(){
            }
        });

    }

    self.is_asking_chatbot = ko.observable(false);
    self.recommendations = ko.observableArray([]);
    self.ask_chat_bot = () => {
        console.log(self.selected_rec());
        self.is_asking_chatbot(true);
        self.match_search_results([]);
        self.recommendations([]);
        self.error();
        fetch(scvm.web_host + '/api/admin/recommendation/ask-chatbot', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                "uuid": self.selected_rec().event_uuid || self.selected_rec().recommendation_uuid,
                "info": self.selected_rec().additional_info,
                "latitude": self.selected_rec().latitude,
                "longitude": self.selected_rec().longitude,
                "lineup": self.selected_rec().besetzung,
                "title": self.selected_rec().event_title,
                "event_type": self.selected_rec().event_type,
                "genres": self.selected_rec().genres,
                "budget": self.selected_rec().max_fee,
            }),
        })
        .then(response => response.json())
        .then(data => {
            //console.log('Success:', data);
            if (data.success){
                //console.log(data.message);
                for (const artist of data.recommendations) {
                    artist.fee = ko.observable(artist.fee);
                    //console.log(artist);
                }
                self.recommendations(data.recommendations);
                notyf.success("chatbot asked");
            }
            else{
                notyf.error(data.message);
            }
        })
        .catch((error) => {
            console.error('Error:', error);
        })
        .finally(() => {
            self.is_asking_chatbot(false);
        });
    }
};
